import { render, staticRenderFns } from "./BusinessEmployees.vue?vue&type=template&id=242298f0"
import script from "./BusinessEmployees.vue?vue&type=script&lang=js"
export * from "./BusinessEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BusinessEmployeesInvite: require('/opt/atlassian/pipelines/agent/build/components/business/BusinessEmployeesInvite.vue').default,UserItem: require('/opt/atlassian/pipelines/agent/build/components/user/UserItem.vue').default})
